import { render, staticRenderFns } from "./CatSlider.vue?vue&type=template&id=2b9820d7&scoped=true"
import script from "./CatSlider.vue?vue&type=script&lang=js"
export * from "./CatSlider.vue?vue&type=script&lang=js"
import style0 from "./CatSlider.vue?vue&type=style&index=0&id=2b9820d7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9820d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b9820d7')) {
      api.createRecord('2b9820d7', component.options)
    } else {
      api.reload('2b9820d7', component.options)
    }
    module.hot.accept("./CatSlider.vue?vue&type=template&id=2b9820d7&scoped=true", function () {
      api.rerender('2b9820d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CatSlider.vue"
export default component.exports